import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from '@/react-query/api';

import { usePreferences } from '../usePreferences';

export interface VoiceNoteTemplateSectionField {
  key: string;
  label?: string;
  defaultValue?: string | number | boolean | null;
  availableValues?: string[];
}

export interface VoiceNoteTemplateSection {
  id: string;
  order: number;
  key: string;
  label: string;
  description: string;
  /** When present, these are the actual variable/field keys (e.g. for suggested values). */
  fields?: VoiceNoteTemplateSectionField[];
}

export interface VoiceNoteTemplateCreator {
  type: 'organization' | 'practice';
  id: string;
  name: string;
}

export interface VoiceNoteTemplate {
  id: string;
  name: string;
  type: string;
  namespace: string;
  description: string | null;
  userInstructions: string | null;
  createdBy: VoiceNoteTemplateCreator | null;
  sections: VoiceNoteTemplateSection[];
}

export const useVoiceNoteTemplates = (namespace?: string) => {
  const { data: preferences } = usePreferences();
  const isVideaNotesEnabled = preferences?.isVideaNotesEnabled;

  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery({
    queryKey: [
      'voice-note-templates',
      currentPracticeId,
      currentOrganizationId,
      namespace,
    ],
    queryFn: async () => {
      return makeAPIRequestReactQuery<VoiceNoteTemplate[]>(
        '/voice-note-templates',
        namespace ? { namespace } : {},
        'get',
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            practice: currentPracticeId,
            org: currentOrganizationId,
          },
        },
      );
    },
    enabled:
      currentPracticeId !== undefined &&
      currentOrganizationId !== undefined &&
      isVideaNotesEnabled === true,
  });
};
